import type { SVGProps } from "react";

/**
 * volume-off, sound-off
 * @category Sound & Music
 */
export default function IconVolumeOffFill(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='currentColor' aria-hidden {...props}>
      <path d='M11.02 3.212A1.25 1.25 0 0 1 13 4.226v15.548a1.25 1.25 0 0 1-1.98 1.014l-4.935-3.552a1.25 1.25 0 0 0-.73-.236H3.75A2.75 2.75 0 0 1 1 14.25v-4.5A2.75 2.75 0 0 1 3.75 7h1.605c.262 0 .518-.082.73-.236zM22.03 10.53a.75.75 0 1 0-1.06-1.06l-1.591 1.59-1.591-1.59a.75.75 0 0 0-1.061 1.06l1.591 1.591-1.591 1.591a.75.75 0 0 0 1.06 1.061l1.592-1.59 1.59 1.59a.75.75 0 1 0 1.061-1.06l-1.59-1.592z' />
    </svg>
  );
}
